import React, { useState } from "react";
import styles from "./EventsPage.module.css";
import { useHistory } from "react-router-dom";
import classNames from "classnames";
import { v4 } from "uuid";
import _ from "lodash";

import Button from "shared/Button";
import EventInfoCard from "./EventInfoCard";
import CreateEventModal from "./CreateEventModal";

// Mock Data
import { WithDetails as EventInfoCardWithDetailsData } from "./EventInfoCard/EventInfoCard.stories";

const mockData = [
  { ...EventInfoCardWithDetailsData.args.event, id: 0 },
  {
    ...EventInfoCardWithDetailsData.args.event,
    id: 1,
    name: "FED 2021",
    date: "10-01-2021",
    complaints: 100,
  },
  {
    id: 2,
    name: "Family Reunion",
    center: "Spokane Event",
    city: "Spokane",
    state: "Washington",
    date: "06-06-2021",
    complaints: 12,
  },
  {
    ...EventInfoCardWithDetailsData.args.event,
    id: 3,
    complaints: 14,
  },
  {
    ...EventInfoCardWithDetailsData.args.event,
    id: 4,
    complaints: 14,
  },
  {
    ...EventInfoCardWithDetailsData.args.event,
    id: 5,
    complaints: 14,
  },
];

/**
 * Structural component.
 * Events page for Security Portal.
 */
export function EventsPage() {
  // Redirect to Incidents page.
  const history = useHistory();

  return (
    <section className={styles.container}>
      <div className={styles.header}>
        <h1>EVENTS</h1>
      </div>
      <div className={styles["info-container"]}>
        {mockData.map((infoCard) => (
          <div className={styles["card-div"]} key={v4()}>
            <EventInfoCard
              event={_.omit(infoCard, "id")}
              onClick={() =>
                history.push({
                  pathname: `/security/event/${infoCard.id}`,
                  state: _.omit(infoCard, "id"),
                })
              }
            />
          </div>
        ))}
      </div>
    </section>
  );
}
